const backdrop = require("bootstrap/js/dist/util/backdrop");

// Loads and bootstraps bootstrap modals on turbo "modal" frame loads
async function initBootstrapModals(event) {
  if (event.target.id == "modal") {
    const Modal = (await import("bootstrap/js/dist/modal")).default;
    let modalElement = event.target.closest(".modal");

    if (!modalElement.classList.contains("show")) {
      let options = { backdrop: "static" };
      let modal = new Modal(modalElement, options);
      modal.show();
    }
  }
}

const flashClose = () => {
  document.querySelectorAll(".btn-close").forEach((button) => {
    button.addEventListener("click", () => {
      button.parentElement.remove();
    });
  });
  
  // Auto-dismiss flash alerts after 10 seconds - Bootstrap's fade out animation
  document.querySelectorAll("#app-flash .alert").forEach((alert) => {
    setTimeout(() => {
      if (alert.parentElement) {
        alert.classList.remove('show');
        setTimeout(() => {
          if (alert.parentElement) {
            alert.remove();
          }
        }, 150); // Wait for fade animation to complete
      }
    }, 10000);
  });
};

document.documentElement.addEventListener("turbo:frame-render", initBootstrapModals);
document.addEventListener("turbo:load", flashClose);
